import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import SOAPageUI from './SOAPageUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class SOAPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      errorList: null,
      accountStatementList: null,
      onSoaDownloadRequested: false
    }
  }

  render() {

    return (
      <SOAPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        account={this.state.account}
        accountStatementList={this.state.accountStatementList}
        onSoaDownloadRequested={this.state.onSoaDownloadRequested}
        onSoaDownloadClick={this.onSoaDownloadClick}
        onSoaPdfDownloadClick={this.onSoaPdfDownloadClick}
        onRefreshClick={this.onRefreshClick}
        //
        updateDescMode={this.state.updateDescMode}
        onUpdateDescClick={this.onUpdateDescClick}
        onUpdateDescCancel={() => { this.setState({ updateDescMode: false }) }}
        selectedTxn={this.state.selectedTxn}
      />
    )
  }

  onUpdateDescClick = (event) => {
    let transactionId = event.currentTarget.getAttribute('data-id')
    let selectedTxn = this.state.accountStatementList.filter(txn => txn.transactionId === transactionId)[0]
    this.setState({ updateDescMode: true, selectedTxn: selectedTxn })
  }

  componentDidMount() {
    this.getAccounts(this.props.context)
    this.getAccountStatement(this.props.context)
  }

  getAccountStatement(context) {
    const accountId = this.props.match.params.accountId

    const cacheManager = new CacheManager({
      resource: `/api/accounts/${accountId}/reports/accountStatement`,
      cacheKey: CacheKeys.SOA(accountId),
      callback: this.getAccountStatementCallback,
      ttlInSecs: 600,
    })

    cacheManager.getObject2(context)
  }

  getAccountStatementCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      accountStatementList: response.accountStatementList,
    })
  }

  onSoaDownloadClick = () => {
    let context = this.props.context
    const accountId = this.props.match.params.accountId
    this.setState({ onSoaDownloadRequested: true })
    RestApiUtils.get(context, `/api/accounts/${accountId}/reports/accountStatement/excel/fileDownloadSignedUrl`,
      this.onSoaDownloadClickCallback, {})
  }

  onSoaDownloadClickCallback = (response) => {
    this.setState({ onSoaDownloadRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onSoaPdfDownloadClick = () => {
    let context = this.props.context
    const accountId = this.props.match.params.accountId
    // this.setState({ onSoaDownloadRequested: true })
    RestApiUtils.get(context, `/api/accounts/${accountId}/reports/accountStatement/pdf/fileDownloadSignedUrl`,
      this.onSoaPdfDownloadClickCallback, {})
  }

  onSoaPdfDownloadClickCallback = (response) => {
    // this.setState({ onSoaDownloadRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    const { context } = this.props
    CacheManager.removeObject(CacheKeys.SOA(this.props.match.params.accountId))
    this.setState({ accountStatementList: null, errorList: null })
    this.getAccountStatement(context)
  }
}

export default withRouter(SOAPageSF)
